<div class="org-tree-container">
  <ul>
    @for (node of filterTree(orgTree); track node) {
      <li>
        <input type="checkbox"
          [checked]="node.selected"
          (change)="onNodeChecked(node, $event)">
          <span class="m-1">{{ node.name }}</span>
          @if (node.children && node.children.length) {
            <ul>
              @for (child of node.children; track child) {
                <li>
                  <input type="checkbox"
                    [checked]="child.selected"
                    (change)="onNodeChecked(child, $event)">
                    <span class="m-1">{{ child.name }}</span>
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    </div>
